export function GetNodeParentObj(aNode) {
  var dbObj = aNode.GetDataObj();
  if (dbObj) {
    var parentDBObj = dbObj.GetParent();
    if (parentDBObj) return parentDBObj;
  }

  return null;
}
